import { Component } from '@angular/core';
import { AppSpinnerService } from './services/app-spinner.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'shore-web';

  constructor(public appSpinnerService: AppSpinnerService) {
     /* const selectedApp = localStorage.getItem("selectedApp");
  const appTitles = {
      analytics: "Safety Rating App",
      safetychampion: "Safety Champion App"
    };

    document.title = appTitles[selectedApp] || document.title; */
  }
}
